/// <amd-module name="SuiteCommerce.ItemRecSys.ScenarioService"/>
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
define("SuiteCommerce.ItemRecSys.ScenarioService", ["require", "exports", "SuiteCommerce.ItemRecSys.Scenario", "SuiteCommerce.ItemRecSys.Common.Helper"], function (require, exports, Scenario_1, Helper_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.ScenarioService = void 0;
    var ScenarioService = /** @class */ (function () {
        function ScenarioService() {
            this.fetchPromise = null;
            this.featureDisabled = false;
            this.fetchPromise = this.fetchAsync();
        }
        ScenarioService.get = function () {
            if (ScenarioService.instance === null) {
                ScenarioService.instance = new ScenarioService();
            }
            return ScenarioService.instance;
        };
        ScenarioService.prototype.fetchAsync = function () {
            if (this.fetchPromise === null) {
                this.fetchPromise = jQuery.ajax({ url: ScenarioService.url });
            }
            return this.fetchPromise;
        };
        ScenarioService.prototype.getScenarios = function () {
            return __awaiter(this, void 0, void 0, function () {
                var response, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.fetchAsync()];
                        case 1:
                            response = _a.sent();
                            // we can be interactive in SMT
                            if ((0, Helper_1.isCmsAdmin)()) {
                                this.fetchPromise = null;
                            }
                            if (response == "FEATURE_DISABLED")
                                this.featureDisabled = true;
                            else
                                return [2 /*return*/, response.reduce(function (obj, item) { return (obj[item.id] = new Scenario_1.Scenario(item), obj); }, {})];
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            console.log('ItemRecSysWidget: Scenario service fetch failed', e_1);
                            this.fetchPromise = null;
                            return [3 /*break*/, 3];
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        ScenarioService.prototype.getScenarioById = function (id) {
            return __awaiter(this, void 0, void 0, function () {
                var scenarios;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4 /*yield*/, this.getScenarios()];
                        case 1:
                            scenarios = _a.sent();
                            if (this.featureDisabled)
                                return [2 /*return*/, { id: -1, name: "Feature Disabled", usecase: Scenario_1.RecommendationUsecase.SHOPPER_TRANSACTIONS_HISTORY, isinactive: 'T' }];
                            else
                                return [2 /*return*/, scenarios[id]];
                            return [2 /*return*/];
                    }
                });
            });
        };
        ScenarioService.SCENARIO_SVC_SCRIPT = 'customscript_ns_recsys_wgt_service';
        ScenarioService.SCENARIO_SVC_DEPLOY = 'customdeploy_ns_recsys_wgt_service';
        ScenarioService.url = (0, Helper_1.getSuiteletUrl)(ScenarioService.SCENARIO_SVC_SCRIPT, ScenarioService.SCENARIO_SVC_DEPLOY, { service: 'getScenarios' });
        ScenarioService.instance = null;
        return ScenarioService;
    }());
    exports.ScenarioService = ScenarioService;
});
